require('../css/help.scss');

$(() => {
    const accordian = $('.accordion');
    accordian.on('show.bs.collapse', (event) => {
        const img = $(event.target).siblings('.card-header').find('img.chevron');
        img.attr('src', img.attr('src').replace('down', 'up'));
    });

    accordian.on('hide.bs.collapse', (event) => {
        const img = $(event.target).siblings('.card-header').find('img.chevron');
        img.attr('src', img.attr('src').replace('up', 'down'));
    });
});
